module.exports = __webpack_public_path__ + "img/3D.b38eeea7.png";